"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/ValueAddedSolutions/On-Demand-Manufacturing/HowitWorks";

const STEPS = [
	{ keyPrefix: "howItWorksStep1", image: `${IMAGE_BASE}/11-js-upload-design-file.webp` },
	{ keyPrefix: "howItWorksStep2", image: `${IMAGE_BASE}/12-js-get-quote-with-dfm.webp` },
	{ keyPrefix: "howItWorksStep3", image: `${IMAGE_BASE}/13-js-delivery.webp` },
] as const;

export default function OnDemandHowItWorks() {
	const t = useTranslations("new-on-demand-manufacturing");
	const [titleFirstWord, ...titleRestWords] = t("howItWorksTitle").split(/\s+/);
	const titleRest = titleRestWords.join(" ");

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col gap-5 sm:mb-8 md:mb-10 md:flex-row md:items-start md:justify-between lg:mb-12">
					<div>
						<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							<span className="flex items-center gap-4">
								<span>{titleFirstWord}</span>
								<span className="h-[3px] w-16 bg-themePrimary400 sm:w-20 md:w-[90px]" aria-hidden="true" />
							</span>
							{titleRest && <span className="block">{titleRest}</span>}
						</h2>
					</div>
					<Link
						href="/upload"
						className="inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("howItWorksGetQuote")}
					</Link>
				</header>

				<div className="grid gap-6 md:grid-cols-3 md:gap-8">
					{STEPS.map((step) => (
						<article key={step.keyPrefix} className="flex h-full flex-col bg-[#f5f5f5] p-6 sm:p-7">
							<div className="mb-5 flex items-baseline gap-3">
								<span className="text-lg font-bold text-themePrimary400 sm:text-xl">
									{t(`${step.keyPrefix}Number`)}
								</span>
								<h3 className="text-lg font-bold text-black sm:text-xl">{t(`${step.keyPrefix}Title`)}</h3>
							</div>
							<p className="mb-6 text-sm leading-relaxed text-black md:text-base">
								{t(`${step.keyPrefix}Desc`)}
							</p>
							<div className="relative mt-auto aspect-[4/3] w-full bg-[#ffffff]">
								<Image
									src={step.image}
									alt={t(`${step.keyPrefix}ImageAlt`)}
									fill
									className="object-contain p-3"
									sizes="(max-width: 768px) 100vw, 33vw"
								/>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
